import type { AlertProps, TagProps } from '@vtex/shoreline'

/**
 * Os status do produto chegam em dois vocabulários: as variantes de alerta
 * (`success`, `warning`, `critical`...) e os estados de pedido do chat
 * (`waiting_payment`, `in_delivery`...). Os dois caem nas cores do Tag.
 */
const tagColorByStatus: Record<string, TagProps['color']> = {
  success: 'green',
  order_placed: 'green',
  confirmed_order: 'green',
  order_delivered: 'green',

  success_alert: 'teal',

  warning: 'yellow',
  waiting_payment: 'yellow',
  waiting_delivery: 'yellow',
  waiting_picking: 'yellow',
  in_picking: 'yellow',
  in_delivery: 'yellow',

  danger: 'red',
  critical: 'red',
  order_canceled: 'red',

  info: 'cyan',
  informational: 'cyan'
}

/**
 * Aceita nulo porque `Status` pode ser montado sem `status` nem `template`, e
 * aceita as variantes do `Alert` porque é delas que vêm `critical` e
 * `informational` (`StatusBar/statusType.ts`).
 */
export const getStatusTagColor = (
  status?: StatusType | StatusTemplates | AlertProps['variant'] | null
): TagProps['color'] => (status && tagColorByStatus[status]) || 'gray'
